import request from 'umi-request';

export async function queryValidateConnection(connectionId, callbackData = null) {
  const url = callbackData ? '/connection/validate' : `/connection/validate/${connectionId}`;

  return request(url, {
    method: 'POST',
    data: callbackData || {},
  });
}

export async function queryAuthorizeConnection(connectionId, redirectUri) {
  const params = redirectUri ? { redirectUri } : {};
  return request(`/connection/authorize/${connectionId}`, {
    method: 'GET',
    params,
  });
}
